import { compose, isNil, not, prop, propOr } from 'ramda';

import fetch from 'features/common/fetch';

import { NAME } from './constants';

const { urls } = fetch.constants;

const getRoot = prop(NAME);

export const getProgress = compose(prop('progress'), getRoot);
export const getIsProcessRunning = compose(not, isNil, getProgress);
export const getSelectedProcess = compose(prop('selectedProcess'), getRoot);
export const getSidebarFormValuesCache = compose(propOr(null, 'formDataCache'), getRoot);
export const getLastRequestBody = compose(prop('body'), fetch.selectors.getLastRequest(urls.contactList));
